export const SET_SUPPLIER = 'setSupplier'
export const SET_SUPPLIERS = 'setSuppliers'
export const SUPPLIER_RESET = 'supplierReset'
export const SUPPLIER_RESET_STATE = 'supplierResetState'
export const SET_SUPPLIER_PAGINATION = 'setSupplierPagination'
export const SET_SUPPLIER_ACTIVE = 'setSupplierActive'